// Stub for streamdown package that we don't use
// @copilotkitnext/react imports this, but we don't use the components that need it

export const Streamdown = () => null;
